var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.size, 'outer-container']},[_c('div',{class:[_vm.size, ("ga-" + _vm.color), 'loader-container']},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }